import React from 'react';
import LateralMenu from '../LateralMenu';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_approved_companies.png';
import collapsedLogo from '../../../assets/icon_approved_companies.png';
import { faFilePen } from '@fortawesome/pro-regular-svg-icons';
import { faHandHoldingBox } from '@fortawesome/pro-solid-svg-icons';

export default function ThirdPartyApprovedCompaniesLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [];

    if (authenticatedUser?.permissions.third_party_approved_companies_manage_inscriptions ) {
        items.push({
            icon: faFilePen,
            text: translate('inscriptionsManagement'),
            action: () => navigation.navigate('ThirdPartyApprovedCompanies', { screen: 'InscriptionsManagement' }),
            selected: selectedMenu == 'inscriptions-management'
        });
    }

    if (authenticatedUser?.permissions.manage_third_party_donated_cameras) {
        items.push({
            icon: faHandHoldingBox,
            text: translate('donatedCameras'),
            action: () => navigation.navigate('ThirdPartyApprovedCompanies', { screen: 'DonatedCamerasList' }),
            selected: selectedMenu == 'donated-cameras'
        });
    }

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={items}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
